@if (!isBorderStyling) {
  <div>
    <div fxLayout="row" fxLayoutAlign="center">
      <mat-icon id="searchIcon" matPrefix>search</mat-icon>
      <mat-form-field class="autocomplete__input-container">
        <input matInput #search
          placeholder="{{placeholder}}"
          [matAutocomplete]="auto"
          [formControl]="formCtrl"
          (keyup)="onSearch($event.target.value)"/>
      </mat-form-field>
    </div>
    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="selectOption($event.option.value)"
      class="autocomplete__results-container">
      @if (!loading) {
        @for (item of items; track (item.customerUid || item.id || item.fullName || item.name || 'item') + '|' + $index) {
          <mat-option [value]="item">
            {{ item.fullName || item.name }}
          </mat-option>
        }
        @if (items.length < 1) {
          <mat-option [disabled]="true">
            {{noResultsText}}
          </mat-option>
        }
      }
      @if (loading) {
        <mat-option
          fxLayout="row"
          fxLayoutAlign="center center"
          class="autocomplete__loading-container"
          [disabled]="true" [cfaLoading]="loading">
        </mat-option>
      }
    </mat-autocomplete>
  </div>
}
@if (isBorderStyling) {
  <div class="autocomplete__border-wrapper">
    @if (headerText) {
      <div class="autocomplete__header-text">{{headerText}}</div>
    }
    <div matAutocompleteOrigin
      #origin="matAutocompleteOrigin"
         [ngClass]="{'autocomplete__search': !isWithDropdown,
                     'autocomplete__search-with-dropdown': isWithDropdown,
                     'autocomplete__search-with-dropdown-desktop': isWithDropdown && !isMobile,
                     'autocomplete__search-with-dropdown-mobile': isWithDropdown && isMobile,
                     'autocomplete__border-on-autocomplete-open': !isWithDropdown && isAutoCompleteOpen,
                     'autocomplete__border-on-autocomplete-close': !isWithDropdown && !isAutoCompleteOpen,
                     'autocomplete__with-dd-border-on-autocomplete-open': isWithDropdown && isAutoCompleteOpen,
                     'autocomplete__with-dd-border-on-autocomplete-close': isWithDropdown && !isAutoCompleteOpen}"
      fxLayout="row"
      fxLayoutAlign="start center">
      <mat-icon id="borderedSearchIcon" matPrefix class="autocomplete__search-icon">search</mat-icon>
      <input type="text"
        #trigger="matAutocompleteTrigger"
        [ngClass]="{'autocomplete__search-input': !isWithDropdown, 'autocomplete__search-input-with-dropdown': isWithDropdown}"
        [placeholder]="placeholder"
        [formControl]="formCtrl"
        [matAutocomplete]="auto"
        [matAutocompleteConnectedTo]="origin"
        [matAutocompletePosition]="'below'"
        (keyup)="onSearch($event.target.value)">
      @if (formCtrl.value && shouldMaintainSelectionText) {
        <button type="button" matSuffix class="cfa-plain-button cfa-plain-button--inline" aria-label="Close" (click)="removeSearchTerm()"><mat-icon class="autocomplete__search-close">close</mat-icon></button>
      }
      <mat-autocomplete #auto="matAutocomplete"
        class="autocomplete__results-container"
        (optionSelected)="selectOption($event.option.value)"
        (opened)="isAutoCompleteOpen = true"
        (closed)="isAutoCompleteOpen = false">
        @if (!loading) {
          @for (item of items; track (item.customerUid || item.id || item.fullName || item.name || 'item') + '|' + $index) {
            <mat-option [value]="item">
              {{ item.fullName || item.name }}
            </mat-option>
          }
          @if (items.length < 1) {
            <mat-option [disabled]="true">
              {{noResultsText}}
            </mat-option>
          }
        }
        @if (loading) {
          <mat-option
            fxLayout="row"
            fxLayoutAlign="center center"
            class="autocomplete__loading-container"
            [disabled]="true"
            [cfaLoading]="loading">
          </mat-option>
        }
      </mat-autocomplete>
    </div>
  </div>
}
